const domain = new URL(window.location.href).hostname;
const getCurrentEnv = (): 'dev' | 'test' | 'prod' => {
  switch (domain) {
    case 'localhost':
      return 'dev';
    case '101.43.101.235':
      return 'test';
    default:
      return 'prod';
  }
};

export const currentEnv = getCurrentEnv();

export const isTest = currentEnv === 'test' || currentEnv === 'dev';

export const isProd = currentEnv === 'prod';
